import { createFileRoute } from "@tanstack/react-router"
import { Dashboard } from "modules/dashboard/components"

import "modules/dashboard/lang"
import "modules/insights/lang"

export const Route = createFileRoute("/_base/_auth/insights/")({
  component: Dashboard,
})
